import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
require('moment/locale/fr')

import "./index.css";
import "./css/tabulator.css";
import "./css/b-table.css";
import "./css/jsoneditor.css";
import "./css/cascader-select.css";
import "./css/autocomplete.css";
import "./css/querybuilder.css";


import Autocomplete from "@trevoreyre/autocomplete-vue";
// import '@trevoreyre/autocomplete-vue/dist/style.css'

import 'ace-builds/src-noconflict/ace';
import "ace-builds/webpack-resolver";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import jQuery from 'jquery'
import bootstrap from 'bootstrap'

import 'bootstrap/dist/css/bootstrap.css'
global.jQuery = jQuery
global .$ = jQuery

import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

import VueSimpleMarkdown from "vue-simple-markdown";
import "vue-simple-markdown/dist/vue-simple-markdown.css";

import LoadScript from "vue-plugin-load-script";

import VueTabulator from "vue-tabulator";
import "vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4.scss";

import Notifications from "vue-notification";

import VuePapaParse from "vue-papa-parse";

import VueObserveVisibility from "vue-observe-visibility";

import UUID from "vue-uuid";

import VueSimpleAlert from "vue-simple-alert";

import panZoom from "vue-panzoom";

Vue.prototype.moment = moment;

import VCalendar from 'v-calendar';

import { VueReCaptcha } from 'vue-recaptcha-v3'

if (process.env.VUE_APP_RECAPTCHA)
{
    Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA,  loaderOptions: { autoHideBadge: true }})
}

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
    debug: false,
    connection: `${process.env.VUE_APP_SAAS_BACK}`,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: { } //Optional options
}))

Vue.use(VueSimpleAlert);
Vue.use(VueSidebarMenu);
Vue.use(VueSimpleMarkdown);
Vue.use(BootstrapVue);
Vue.use(LoadScript);
Vue.use(VueTabulator);
Vue.use(VuePapaParse);
Vue.use(VueObserveVisibility);
Vue.use(Notifications);
Vue.use(panZoom);
Vue.use(UUID);
Vue.use(Autocomplete);

Vue.use(VCalendar);

Vue.use(require('vue-moment'), {
    moment
})

import "../public/js/query-builder.default.min.css";
import "../public/js/query-builder.min.js";
import "../public/js/query-builder-fr.js";

import edit_tabulator_conditions from "./components/edit_tabulator_conditions.vue";
Vue.component('edit_tabulator_conditions', edit_tabulator_conditions)
import data_component from "./components/data.vue";
Vue.component("data_component", data_component)

Vue.config.productionTip = false;

import contenteditable from 'vue-contenteditable'
Vue.use(contenteditable)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

import en from "./locales/en/translate.json";
import fr from "./locales/fr/translate.json";

var messages = {
    en: en,
    fr: fr,
}

const i18n = new VueI18n({
    locale: 'fr', // set locale
    messages, // set locale messages
  })

new Vue({
    i18n,
    sockets: {
        connect: function () {
            //console.log('socket connected')
            //console.log(this.$socket.id)
        },
        error: function(err)
        {
            //this.$store.commit("setBack", false);
        },
        disconnect: function()
        {
            //this.$store.commit("setBack", false);
        },
        reconnect: function()
        {
            //this.$store.commit("setBack", true);
        }
	},
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
